<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <li style="font-size: 13px; flex: 1">{{ state.model.name }}</li>
        <li>
          <el-button
            type="primary"
            link
            icon="Select"
            @click="state.showCheck = true"
            v-if="
              state.model?.status === 0 &&
              state.model?.is_show_check_button &&
              $judge_auth('111')
            "
          >
            点击审核
          </el-button>
          <el-button
            v-if="state.model?.status === 1 && $judge_auth('111')"
            type="primary"
            link
            icon="Printer"
            v-print="printObj"
          >
            打印
          </el-button>
        </li>
      </ul>
      <ul style="padding: 0 10px">
        <el-descriptions
          :column="4"
          border
          style="overflow-x: auto; margin-top: 10px"
          class="desc-label-nowrap"
          size="large"
        >
          <el-descriptions-item label="名称" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.name }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="状态" label-align="right">
            <div style="min-width: 200px">
              <c_status
                v-if="
                  state.model.status != null && state.model.status != undefined
                "
                arr-name="salaryapply_status"
                :value="state.model?.status"
                :key="state.model.status"
              ></c_status>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="所属客户" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.customer_name || "-" }}
            </div>
          </el-descriptions-item>
          <!-- <el-descriptions-item label="扣缴义务人" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.withholding_agent_name || "-" }}
            </div>
          </el-descriptions-item> -->
          <el-descriptions-item label="薪资所属期" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.month || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="约定发薪日期" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.pay_date || "-" }}
            </div>
          </el-descriptions-item>
          <!-- <el-descriptions-item label="已收款" label-align="right">
            <div style="min-width: 200px">
              {{ $priceFormat(state.model.money) }}
            </div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item label="已发放金额" label-align="right">
            <div style="min-width: 200px">
              {{ $priceFormat(state.model.payed_money) }}
            </div>
          </el-descriptions-item> -->
          <el-descriptions-item label="本次发放金额" label-align="right">
            <div style="min-width: 200px">
              <c_money
                :size="20"
                style="font-weight: 600"
                :value="state.model.money"
              />
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="本次发放数量" label-align="right">
            <div style="min-width: 200px">
              {{ $numberFormat(state.model.employee_num) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="应支付供应商总金额" label-align="right">
            <div style="min-width: 200px">
              <c_money
                :size="20"
                :value="state.model.payable_supplier_amount"
                style="color: #ffa500"
              />
            </div>
          </el-descriptions-item>
          <el-descriptions-item
            label="关联工资表"
            label-align="right"
            :span="555"
          >
            <div style="min-width: 200px; display: flex; align-items: center">
              <text>{{ state.model.payroll?.name }}</text>
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                @click="$onCopy(state.model.payroll_order_id)"
              >
                {{ "(" + state.model.payroll_order_id + ")" }}
              </text>
              <!-- <el-popover width="60%" trigger="hover">
                <template #reference>
                  <el-icon
                    size="16"
                    color="#1E90FF"
                    style="margin-left: 10px; cursor: pointer"
                  >
                    <View />
                  </el-icon>
                </template>
                <template #default>
                  <div style="font-weight: 600; font-size: 13px">基本信息</div>
                  <el-descriptions
                    :column="3"
                    border
                    style="margin: 10px"
                    class="desc-label-nowrap"
                  >
                    <el-descriptions-item label="名称" label-align="right">
                      <div style="min-width: 200px">
                        {{ state.model.name }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="状态" label-align="right">
                      <div
                        style="min-width: 200px"
                        :style="{
                          color: state.model.status == 1 ? '#1e90ff' : '#f00',
                        }"
                      >
                        {{ state.model.status == 1 ? "正常" : "停用" }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item
                      label="统一社会信用代码"
                      label-align="right"
                    >
                      <div style="min-width: 200px">
                        {{ state.model.unified_social_credit_identifier }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="所属行业" label-align="right">
                      <div style="min-width: 200px">
                        {{ state.model.d_customer_type_name }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="所属地区" label-align="right">
                      <div style="min-width: 200px">
                        {{
                          state.model.province +
                          (state.model.city || "") +
                          (state.model.district || "")
                        }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="详细地址" label-align="right">
                      <div style="min-width: 200px">
                        {{ state.model.address }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item
                      label="对接人姓名"
                      label-align="right"
                    >
                      <div style="min-width: 200px">
                        {{ state.model.contact_name }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="职务" label-align="right">
                      <div style="min-width: 200px">
                        {{ state.model.contact_job }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="联系方式" label-align="right">
                      <div style="min-width: 200px">
                        {{ state.model.contact_name }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item
                      label="个税承担类型"
                      label-align="right"
                    >
                      <div style="min-width: 200px">
                        {{ state.model.tax_mode == 0 ? "个人" : "公司" }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="签单时间" label-align="right">
                      <div style="min-width: 200px">
                        {{ state.model.contract_time }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="负责人" label-align="right">
                      <div style="min-width: 200px; display: flex">
                        {{ state.model.belonger_name }}
                        <text v-if="state.model.belonger_department_name">
                          {{ "/" + state.model.belonger_department_name }}
                        </text>
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="服务类型" label-align="right">
                      <div style="min-width: 200px; display: flex">
                        {{ state.model.d_service_name }}
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="服务费" label-align="right">
                      <div style="min-width: 200px; display: flex">
                        <template v-if="state.model.service_cost_calc_rate > 0">
                          <text
                            v-if="
                              state.model.service_cost_calc_mode == 1 ||
                              state.model.service_cost_calc_mode == 2
                            "
                          >
                            {{
                              state.model.service_cost_calc_mode == 1
                                ? "应发工资的"
                                : "应发工资-代扣项目的"
                            }}
                          </text>
                          {{ state.model.service_cost_calc_rate + "%" }}
                        </template>
                        <template
                          v-if="
                            state.model.service_cost_calc_rate > 0 &&
                            state.model.service_cost > 0
                          "
                        >
                          +
                        </template>
                        <template v-if="state.model.service_cost > 0">
                          <text
                            v-if="
                              state.model.service_cost_type == 1 ||
                              state.model.service_cost_type == 2
                            "
                          >
                            {{
                              state.model.service_cost_type == 1
                                ? "每人每月"
                                : "每人每笔"
                            }}
                          </text>
                          {{ state.model.service_cost + "元" }}
                        </template>
                      </div>
                    </el-descriptions-item>
                  </el-descriptions>
                </template>
              </el-popover> -->
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="是否补发" label-align="right">
            <div style="min-width: 200px">
              {{ state.model?.is_again_pay ? "是" : "否" }}
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </ul>
      <ul
        style="
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
        >
          <el-tab-pane label="工资表明细" name="record">
            <c_Record
              :id="props.data?.id"
              v-if="state.activeName == 'record'"
            ></c_Record>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="log">
            <c_Log
              :id="props.data?.id"
              v-if="state.activeName == 'log'"
            ></c_Log>
          </el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑员工"
      @close="state.showEdit = false"
    >
      <c_EmployeeEdit
        @close="
          state.showEdit = false;
          onLoad();
        "
        :model="state.model"
      ></c_EmployeeEdit>
    </c_popup>
  </transition>
  <el-dialog v-model="state.showCheck" align-center style="width: auto">
    <template #title>
      <div>发薪审核</div>
    </template>
    <el-input
      v-model="state.checkMsg"
      type="textarea"
      style="width: 300px"
      placeholder="请填写审核备注"
    />
    <ul
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
      "
    >
      <el-button type="danger" style="flex: 1" @click="onSubmit(2)"
        >审核不通过</el-button
      >
      <el-button type="success" style="flex: 1" @click="onSubmit(1)"
        >审核通过</el-button
      >
    </ul>
  </el-dialog>
  <div id="printDom" style="display: flex; justify-content: center">
    <table
      cellpadding="3"
      style="border-collapse: collapse; font-size: 60%"
      border="1"
    >
      <tr>
        <td
          :colspan="2"
          style="
            background-color: #cccccc;
            font-weight: 600;
            font-size: 140%;
            text-align: center;
            -webkit-print-color-adjust: exact;
          "
        >
          发薪审核单
        </td>
      </tr>
      <tr>
        <td style="white-space: nowrap">付款理由</td>
        <td>{{ state.model.remark || "无" }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">发薪主体</td>
        <td>{{ state.model.withholding_agent_name }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">经办人/客服专员</td>
        <td>
          {{
            state.model.printer_admin_name +
            "/" +
            state.model.printer_department_name
          }}
        </td>
      </tr>
      <tr>
        <td style="white-space: nowrap">申请时间</td>
        <td>{{ state.model.create_time }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">项目编码</td>
        <td>{{ state.model?.project_no }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">是否垫款</td>
        <td>{{ state.model.is_arrearage ? "是" : "否" }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">发薪人数</td>
        <td>{{ state.model.employee_num }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">付款总额</td>
        <td>{{ state.model.money }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">约定发薪日期</td>
        <td>{{ state.model.pay_date }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">支付对象</td>
        <td>对私</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">付款方式</td>
        <td>银行转账</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">客户名称</td>
        <td>{{ state.model.customer_name }}</td>
      </tr>
      <tr>
        <td style="white-space: nowrap">收款账户信息</td>
        <td>
          {{ state.model.bank_account_name }}
          <br />
          <text style="font-size: 11px">
            {{ state.model.bank_account }}
          </text>
          <br />
          <text style="font-size: 11px">
            {{ state.model.opening_bank }}
          </text>
        </td>
      </tr>
      <tr>
        <td style="white-space: nowrap">工资表信息</td>
        <td>
          {{ state.model.payroll?.name }}
          <br />
          {{ state.model.payroll?.order_id }}
        </td>
      </tr>
      <tr>
        <td style="white-space: nowrap">审批人</td>
        <td>
          <div v-for="item in state.log_data" :key="item">
            {{
              item.add_admin_name +
              " " +
              item.create_time +
              " " +
              item.type_name
            }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  salaryapply_detail,
  salaryapply_check,
  salaryapply_log,
} from "@/http/salaryapply";
import { ElMessage } from "element-plus";

import c_Record from "./Record.vue";
import c_Log from "./Log.vue";
export default {
  components: {
    c_Record,
    c_Log,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const printObj = {
      id: "printDom",
      beforeOpenCallback() {},
    };
    const state = reactive({
      model: {},
      activeName: "record",
    });
    onMounted(() => {
      onLoad();
      onLoadLog();
    });

    const onLoad = () => {
      salaryapply_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };

    const onLoadLog = () => {
      delete state.tableData;

      salaryapply_log({
        salary_apply_id: props.data?.id,
        limit: 0,
        sort_field: "create_time",
        sort_value: "asc",
      }).then((res) => {
        if (res.status == 200) {
          state.log_data = res.data.data?.list;
        }
      });
    };

    const onSubmit = (status) => {
      if (!status && !state.checkMsg) {
        ElMessage({
          type: "warning",
          message: "请填写审核说明",
          grouping: true,
        });
        return false;
      }
      const data = { id: props.data?.id, status, msg: state.checkMsg };
      salaryapply_check(data).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data.msg);
          onLoad();
          state.showCheck = false;
        }
      });
    };

    return { state, props, onSubmit, printObj };
  },
};
</script>
<style scoped lang="less">
@media print {
  @page {
    size: auto;
    margin: 20px;
    page-break-before: always;
  }
  body * {
    visibility: hidden;
  }
  #printDom,
  #printDom * {
    visibility: visible;
  }
  #printDom {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
